import Notes from "../../notes/notes";
import Note from "../../notes/note";
import Task from "../task";
import {NoteType} from "../../notes/@const";

// @ts-ignore
export default class TaskNotes extends Notes {

    private task            : Task

    /**
     * Stores the last saved notes JSON.
     * Used to detect changes, as notes may change after the update API call on save,
     * but before the delta session event is processed.
     */
    public lastSavedJSON?   : JSONObject

    constructor(task: Task, models:Note[]) {
        super(models)

        this.task       = task
    }


    static initFromJson(task:Task, data:any) {

        // filter out all notes with no access
        const notesData = data ? _.filter(data, note=>note.access === gd.const.meeting.noteAccess.PUBLIC || note.userId === gd.session.me.id) : []


        const collection = new TaskNotes(task, [])

        _.map(notesData, (record:JSONObject)=>{
            collection.add(new Note(record))
        })

        collection.sort()

        return collection
    }

    get documents() {
        return _.filter(this.models, (model: Note)=>model.type !== NoteType.WHITEBOARD)
    }

    get whiteboards() {
        return _.filter(this.models, (model: Note)=>model.type === NoteType.WHITEBOARD)
    }

    generateNewName(type?: NoteType) {

        if (type === NoteType.WHITEBOARD) {
            return "Whiteboard " + (_.filter(this.models, (model: Note)=>model.type === NoteType.WHITEBOARD).length + 1)
        }

        return "Page " + (_.filter(this.models, (model: Note)=>model.type !== NoteType.WHITEBOARD).length + 1)
    }

    public async save():Promise<void> {
        this.lastSavedJSON = this.toJSON()

        return gd.api.Task.update(this.task.id, {
            notes   : this.lastSavedJSON
        }).promise()
    }
}
